import React, {useEffect, useState, useRef} from 'react';
import './Label.css';
import ResizeObserver from 'react-resize-observer';

interface LabelProps {
  width:number;
  colItem:any;
  html:any;
  className:any;
}

//const JSON5 = require("json5")

const Label: React.FC<LabelProps> = ({ width, colItem, html, className }) => {

  const updateDimensions = async () => {
    //console.log("updateDimensions()");
    const { current } = await refLabel;
    //console.log(current);

    const cur:any = current ? current  : null;

    if (cur) {
      // @ts-ignore: Object is possibly 'null'
      const node = cur._node;
      var offset,i
      //console.log("w:"+node.getBoundingClientRect().width);
      if (node.getBoundingClientRect().width===0) {
        if (width) {
          setParentWidth(width);
        } else {
          const cnt = node.parentNode.parentNode.childNodes.length;
          offset = 0;
          for(i=0;i<cnt; i++) {
            const elem = node.parentNode.parentNode.childNodes[i].firstChild.parentElement;
            //console.log(i+":"+elem.nodeType+","+elem.nodeName)
            if (node.parentNode.firstChild !== node.parentNode.parentNode.childNodes[i].firstChild) {
  //                offset += elem.offsetWidth;
                  const eee = node.parentNode.parentNode.childNodes[i].firstChild.firstChild.parentElement;
                  let computedStyle = getComputedStyle(eee);
                  //console.log("  :"+computedStyle.width+","+eee.nodeName+","+eee.offsetWidth+","+eee.clientWidth+","+eee.getBoundingClientRect().width+","+eee.style.pixelWidth+","+eee.style.width+","+eee.width);
                  let pos = computedStyle.width.indexOf("px");
                  let width = parseInt(computedStyle.width.substring(0,pos));
                  offset += (width ? width : 0)+23;
            }
          }
          var grid = node.parentNode.parentNode.parentNode.parentElement;
          //console.log(grid.nodeName+","+grid.getBoundingClientRect().width+","+offset);
          if (grid.nodeName!=="ION-GRID") {
            grid = node.parentNode.parentNode.parentNode.parentNode.parentElement;
          }
          setParentWidth(grid.getBoundingClientRect().width-offset-20);
        }
        return
      }
      
      const cnt = node.parentNode.parentNode.childNodes.length;
      offset = 0;
      for(i=0;i<cnt; i++) {
        const elem = node.parentNode.parentNode.childNodes[i].firstChild.parentElement;
        //console.log(i+":"+elem.nodeName)
        if (node.parentNode.firstChild !== node.parentNode.parentNode.childNodes[i].firstChild) {
          offset += elem.offsetWidth;
        }
      }
      //console.log(node.parentNode.parentNode.parentElement.offsetWidth+","+offset);
      setParentWidth(node.parentNode.parentNode.parentElement.offsetWidth-offset-20);
    }
  }

  useEffect(() => {
    // Your code here
    window.addEventListener('resize', updateDimensions);
  }, []);
  
  //var w = 100;

  //var ww = 100 - w;

  const [parentWidth, setParentWidth] = useState(1);
  const refLabel = useRef();

  
    return (
      <>
      <div 
       ref={async el => {
          if (!el) return;
          //console.log("initial width",el.getBoundingClientRect().width);
          updateDimensions();
  
      }} 
      className={className}
      style={{position:"relative",width:parentWidth,margin:colItem.margin,height:colItem.height}}>
      <span dangerouslySetInnerHTML={{__html: html}} style={{width:"100%",top:"0px",left:"0px",display:"inline-block",height:"100%",padding:colItem.padding}}></span>
      </div>
      <ResizeObserver ref={refLabel}
        onResize={(rect) => {
          //console.log('Resized 1. New bounds:', rect.width, 'x', rect.height);
        }}

        onPosition={(rect) => {
          //console.log('Moved 1. New position:', rect.left, 'x', rect.top);
        }}/>
      </>
    )
}

export default Label;
